import { IQuestionnaire } from "./IQuestionnaire";

export interface IQuestionnaireSpecifiable {
  questionnaire: IQuestionnaire;
}

export function instanceOfIQuestionnaireSpecifiable(instance: any): instance is IQuestionnaireSpecifiable {
  return instance && (instance.questionnaire !== undefined);
}
